import React, { useEffect, useState, useCallback } from "react";
import ProfilePicCropper from "../../components/profilePicCropper";

const ProfilePicture = ({ image, userId, isTalentView, isTalentRegister }) => {
  const [showModal, setShowModal] = useState(false);
  const [resizedImage, setResizedImage] = useState(image);

  useEffect(() => {
    setResizedImage(image);
  }, [image]);

  const handleImageClick = useCallback(() => {
    if (resizedImage) {
      setShowModal(true);
    }
  }, [resizedImage]);

  const closeModal = useCallback(() => {
    setShowModal(false);
  }, []);

  // Cleanup object URLs
  useEffect(() => {
    return () => {
      if (resizedImage?.startsWith("blob:")) {
        URL.revokeObjectURL(resizedImage);
      }
    };
  }, [resizedImage]);

  return (
    <div
      className="relative w-[256px] h-[217px] rounded-ten overflow-hidden cursor-pointer"
      onClick={handleImageClick}
    >
      {showModal && (
        <ProfilePicCropper
          imageSrc={resizedImage}
          setResizedImage={setResizedImage}
          closeModal={closeModal}
          userId={userId}
          isTalentView={isTalentView}
          isTalentRegister={isTalentRegister}
        />
      )}

      <img
        src={resizedImage}
        alt="Profile"
        className="block w-full h-full object-cover rounded-ten"
      />
    </div>
  );
};

export default ProfilePicture;
